class ModelModel {
  constructor(obj) {
    this.id = null;
    this.title = null;

    this.image_url = null;
    this.manual_urls = [];

    this.comment = null;
    this.status = null;

    if (obj) {
      Object.assign(this, obj);
    }
  }

  get dto() {
    return this;
  }
}

export default ModelModel;
